import { isProduction } from 'src/shared/helpers/environment';

export * from './favorites';
export * from './frameAncestors';
export * from './palettes';
export * from './routes';

export const AI_GENERATION_APP_ID = 'homeowner-app';

export const GOOGLE_LENS_URL = 'https://lens.google.com/uploadbyurl?url=';

export const HOVER_URL = isProduction()
  ? 'https://hover.to'
  : 'https://staging.hover.to';
